import { render } from "./KeySkills.vue?vue&type=template&id=435dbeb2&scoped=true"
import script from "./KeySkills.vue?vue&type=script&lang=js"
export * from "./KeySkills.vue?vue&type=script&lang=js"

import "./KeySkills.vue?vue&type=style&index=0&id=435dbeb2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435dbeb2"]])

export default __exports__